import React from 'react';
import { routeBoundaryCurve } from '../../utils/mindmap/edgeRouting';
import '../../styles/components/Line.css';

/**
 * Boundary-anchored connection between nodes with stable semantic ports.
 */
const Line = ({
  fromRect,
  toRect,
  side = null,
  opacity = 1,
  isDarkMode = false,
  isSelected = false,
  isMuted = false,
  fromId = null,
  toId = null,
  isLayoutAnimating = false,
}) => {
  // Don't render if coordinates are missing
  if (!fromRect || !toRect) return null;

  const route = routeBoundaryCurve(fromRect, toRect, { side });
  const stroke = isSelected
    ? (isDarkMode ? '#7dd3fc' : '#2563eb')
    : (isDarkMode ? '#64748b' : '#94a3b8');
  const state = isSelected ? 'selected' : isMuted ? 'muted' : 'default';

  return (
    <path
      className={`mind-map-edge mind-map-edge--${state}${isLayoutAnimating ? ' mind-map-edge--layout-transition' : ''}`}
      d={route.path}
      fill="none"
      stroke={stroke}
      strokeWidth={isSelected ? 2.75 : 1.75}
      strokeLinecap="round"
      opacity={isMuted ? Math.min(opacity, 0.28) : opacity}
      data-edge-state={state}
      data-edge-side={route.side || 'automatic'}
      data-edge-from={fromId || undefined}
      data-edge-to={toId || undefined}
      data-edge-position-animating={isLayoutAnimating ? 'true' : 'false'}
      aria-hidden="true"
    />
  );
};

export default Line;
